import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight, Eye, EyeOff } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import api, { apiErr } from "../lib/api";

export default function SetPassword() {
  const { user, loading, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showPw, setShowPw] = useState(false);

  if (!loading && !user) { navigate("/login"); return null; }

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return setError("Password must be at least 6 characters");
    if (pw !== pw2) return setError("Passwords do not match");
    setBusy(true); setError("");
    try {
      await api.post("/auth/set-password", { new_password: pw });
      await refreshUser();
      navigate("/app");
    } catch (e2) { setError(apiErr(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-aside">
        <div className="login-glow" />
        <Logo scale={1.2} dark />
        <div>
          <div className="eyebrow">Account security</div>
          <div className="login-tag head">Set your <span className="gold-text">new password.</span></div>
          <p style={{ color: "#cfcdc4", maxWidth: 380, marginTop: 18, fontSize: 14 }}>
            For your security, this account requires a new password before you can continue.
            Your old/temporary password is now disabled.
          </p>
        </div>
        <div className="login-foot"><span>PTE Connect</span></div>
      </div>
      <div className="login-card-wrap">
        <form className="login-form" onSubmit={submit}>
          <div className="mi" style={{ background: "var(--green-bg)", color: "var(--green)", width: 42, height: 42, borderRadius: 12, display: "grid", placeItems: "center", marginBottom: 14 }}><ShieldCheck size={22} /></div>
          <h2>Choose a password</h2>
          <p className="sub">Signed in as {user?.email}</p>
          <div className="field"><label>New password</label>
            <div style={{ position: "relative" }}>
              <input className="input" style={{ paddingRight: 38 }} type={showPw ? "text" : "password"} value={pw}
                onChange={(e) => setPw(e.target.value)} data-testid="sp-pw1" autoFocus />
              <button type="button" onClick={() => setShowPw((v) => !v)} data-testid="sp-pw-toggle"
                title={showPw ? "Hide password" : "Show password"}
                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
                         background: "none", border: 0, cursor: "pointer", color: "var(--text-3)", display: "flex" }}>
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <div className="field"><label>Confirm password</label>
            <input className="input" type={showPw ? "text" : "password"} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="sp-pw2" /></div>
          {error && <div style={{ color: "var(--red)", fontSize: 13, marginBottom: 10 }} data-testid="sp-error">{error}</div>}
          <button className="btn-primary" type="submit" disabled={busy} data-testid="sp-submit">
            {busy ? "Saving…" : (<>Set password & continue <ArrowRight size={16} style={{ display: "inline", verticalAlign: "-3px" }} /></>)}
          </button>
          <p style={{ textAlign: "center", marginTop: 14 }}><button type="button" className="link" style={{ color: "var(--text-3)", fontSize: 12 }} onClick={logout}>Sign out instead</button></p>
        </form>
      </div>
    </div>
  );
}
